export default __webpack_public_path__ + "static/media/E0006.987e878f.png";